// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getFamiliesFactory, getFamilyWeeks } from '../../common/repositories';
import BundleRunningAvailabilityTable from './components/bundle-running-availability-table';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import getBundleRunningAvailability from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class BundleRunningAvailability extends Component {

    state = {
        bundleNumber: '',
        familyTypes: [],
        lastWeeks: [],
        selectedFamilyType: '',
        selectedLastWeek: '',
        negativeOnly: '',
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'Y' ).then( response => {

            this.setState( {
                familyTypes: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getFamilyWeeks().then( response => {

            this.setState( {
                lastWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTextChange ( name, val ) {

        if ( name === 'negativeOnly' ) {

            this.setState( {
                [`${name}`]: val.target.checked
            } );
            if ( val.target.checked ) {

                this.props.increaseCounter();
                const searchResult = this.state.results.filter(
                    resObj => resObj.negRuningTotal === true
                );
                this.setState( {
                    results: searchResult
                } );
                this.props.decreaseCounter();

            } else {

                this.refresh();

            }

        } else {

            this.setState( {
                [`${name}`]: val.target.value
            }, () => {

                this.refresh();

            } );

        }

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedLastWeek ) {

            this.props.increaseCounter();

            const { bundleNumber } = this.state;
            const { selectedFamilyType } = this.state;
            const selectedLastWeekVal = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) )
                .weekNumber;
            getBundleRunningAvailability( bundleNumber, selectedFamilyType, selectedLastWeekVal )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            bundleNumber, selectedFamilyType, selectedLastWeek, familyTypes,
            lastWeeks, negativeOnly, results
        } = this.state;

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Bundle Running Availability</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-bundle-running-availability-top-options">
                            <div className="select-options">
                                <LabeledInput
                                    className="bundle"
                                    name="bundleNumber"
                                    isEditable={true}
                                    label="Bundle Number"
                                    maxLength={12}
                                    onChange={this.handleTextChange.bind( this, 'bundleNumber' )}
                                    value={bundleNumber}
                                    isRequired={false}
                                />
                                <OptionsDropDown
                                    className="atp-bundle-running-availability-select"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />
                                <OptionsDropDown
                                    className="atp-bundle-running-availability-select"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />
                                <LabeledInput
                                    className="negativeOnly"
                                    name="negativeOnly"
                                    isEditable={true}
                                    label="Negative Only"
                                    type="checkbox"
                                    maxLength={6}
                                    onChange={this.handleTextChange.bind( this, 'negativeOnly' )}
                                    value={negativeOnly}
                                    isRequired={false}
                                />

                                {selectedFamilyType && selectedLastWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedFamilyType && selectedLastWeek && (
                            <BundleRunningAvailabilityTable
                                results={results}
                                unitCode={this.props.unit.name}
                                totalRows={results.length}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

BundleRunningAvailability.displayName = 'BundleRunningAvailability';
BundleRunningAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( BundleRunningAvailability ) );
